import { ApiService } from "./AbstractApiService";
import qs from "qs";
import { IPageModel } from "@/interfaces/iPageModel";
import {
  ISite,
  ISiteDevices,
  ISiteLocationDevices,
  ISiteDeviceModel,
} from "@/interfaces/iSite";
import {
  ILocation,
  ISiteLocation,
  ISiteLocationDevice,
  ILocationActivity,
} from "@/interfaces/iLocation";
import moment from "moment";
export class LocationAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: LocationAPI | null;
  constructor() {
    super("site");
  }
  public async getLocationList(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<ILocation>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get("locations", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getLocationListOptions(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<ILocation>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get("filter/LOCATION", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getLocation(
    id: number,
    params?: Record<string, string | number>
  ): Promise<ILocation> {
    return this.get(`locations/${id}`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  // siteLocations
  public async siteLocations(
    params?: Record<string, string | number>
  ): Promise<IPageModel<ISiteLocation>> {
    return this.get("siteLocations", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  // addSiteLocations
  public async addSiteLocations(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<ISiteLocation> {
    if (edit) {
      return this.put("siteLocations/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("siteLocations", payload).then(
        (response) => response.data
      );
    }
  }
  public async addLocation(
    payload?: Record<string, string | number>,
    edit?: boolean,
    siteId?: number
  ): Promise<IPageModel<ISite>> {
    if (edit) {
      const url = `locations/${payload?.webId}?siteIds=${siteId}`;
      return this.put(url, payload).then((response) => response.data);
    } else {
      return this.post(`locations?siteIds=${siteId}`, payload).then(
        (response) => response.data
      );
    }
  }
  public async addMultiplesLocation(payload?: Record<string, string | number>) {
    return this.post("siteLocations/assign", payload).then(
      (response) => response.data
    );
  }

  public async getSiteById(id: number): Promise<ISite> {
    return this.get(`sites/${id}`).then((response) => response.data);
  }

  public async getSiteLocationDevicesList(
    params: Record<string, string | number>
  ): Promise<IPageModel<ISiteLocationDevices>> {
    return this.get(`siteDevices`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async addSiteLocationDevicesList(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<ISiteLocationDevices>> {
    if (edit) {
      return this.put(`siteDevices/` + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post(`siteDevices`, payload).then(
        (response) => response.data
      );
    }
  }

  public async getSiteDevicesList(
    params: Record<string, string | number>
  ): Promise<IPageModel<ISiteDevices>> {
    return this.get(`devices`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async addSiteDevicesList(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<ISiteDevices>> {
    if (edit) {
      return this.put(`devices/` + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post(`devices`, payload).then((response) => response.data);
    }
  }
  public async getSite(id: number): Promise<ISite> {
    return this.get(`sites/${id}`).then((response) => response.data);
  }

  public async getDevice(id: number): Promise<ISite> {
    return this.get(`devices/${id}`).then((response) => response.data);
  }

  public async getSiteDeviceList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<ISiteLocationDevice>> {
    return this.service
      .get(`site/locationDevices/`, {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
      })
      .then((response) => response.data);
  }

  public async deleteSiteDevice(
    payload: any
  ): Promise<IPageModel<ISiteDeviceModel>> {
    return this.service
      .delete(`site/siteDevices/`, { data: payload })
      .then((response) => response.data);
  }
  public async deleteLocationDevice(
    payload: any
  ): Promise<IPageModel<ISiteDeviceModel>> {
    return this.service
      .delete(`site/locationDevices/`, { data: payload })
      .then((response) => response.data);
  }

  public async addSiteDevice(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<ISiteDeviceModel>> {
    if (edit) {
      return this.service
        .put(`site/siteDevices` + payload?.webId, payload)
        .then((response) => response.data);
    } else {
      return this.service
        .post(`site/siteDevices`, payload)
        .then((response) => response.data);
    }
  }

  public async getDeviceSiteList(
    id: number,
    params?: Record<string, string | number>
  ): Promise<IPageModel<ISiteDeviceModel>> {
    return this.service
      .get(`site/siteDevices/${id}/sites`, {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
      })
      .then((response) => response.data);
  }

  public async deleteSiteLocation(payload: any): Promise<IPageModel<ISite>> {
    return this.service
      .delete(`site/siteLocations/`, { data: payload })
      .then((response) => response.data);
  }

  public async deleteBulkLocations(payload: any): Promise<IPageModel<any>> {
    return this.service
      .delete(`site/locations/`, { data: payload })
      .then((response) => response.data);
  }

  public async addDeviceSite(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<ISite>> {
    if (edit) {
      return this.service
        .put(`site/siteDevices` + payload?.webId, payload)
        .then((response) => response.data);
    } else {
      return this.service
        .post(`site/siteDevices`, payload)
        .then((response) => response.data);
    }
  }
  public transformDateRangeParams(
    params: Record<string, string | number>
  ): Record<string, string | number> {
    if (
      params &&
      params["startDate"] &&
      `${params["startDate"]}`.split(",").length > 1
    ) {
      const dates = `${params["startDate"]}`.split(",");
      params["startDate"] = moment(dates[0]).format("YYYY-MM-DDTHH:mm:ss[Z]");
      const endDate = moment(dates[1])
        .clone()
        .set({ hour: 23, minute: 59, second: 59 })
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
      params["endDate"] = endDate;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ...rest } = params;
    return rest;
  }
}
